import React from "react";
import classNames from "classnames";


interface HighlightTextProps extends React.ComponentPropsWithoutRef<"span"> {
    query: string;
    keyword?: string;
    highlightClassName: string;
}

const HighlightText = React.forwardRef<HTMLSpanElement, HighlightTextProps>((props, ref) => {
    const { query, keyword, highlightClassName, ...rest } = props;

    const regex = keyword ? new RegExp(`(${escapeRegExp(keyword)})`, "gi") : /.^/;
    const parts = query.split(regex);

    return (
        <span ref={ref}
              {...rest}
        >
            {parts.map((part, index) => (
                <span key={index}
                      className={classNames(regex.test(part) ? highlightClassName : "")}
                >
                    {part}
                </span>
            ))}
        </span>
    );
});

const escapeRegExp = (text: string) => text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export default HighlightText;
